import React from "react";
import "./Css/Features.css";

const Features = () => {
  return (
    <div className="features-page">

      <div className="features-header">
        <h1>Powerful Features for Modern Education</h1>
        <p>Everything you need to manage exams, students, and results in one smart platform.</p>
      </div>

      <div className="features-grid">

        <div className="feature-card">
          <h2>User Management</h2>
          <p>Easily manage teachers, students, and academic activities.</p>
        </div>

        <div className="feature-card">
          <h2>Complete Academic Management</h2>
          <p>Manage teachers, students, exams, and results in one powerful platform.</p>
        </div>

        <div className="feature-card">
          <h2>Smart Administration</h2>
          <p>Streamline academic operations with an easy-to-use system.</p>
        </div>

        <div className="feature-card">
          <h2>All-in-One Education Platform</h2>
          <p>Everything needed to run modern exams and academic activities.</p>
        </div>

      </div>

    </div>
  );
};

export default Features;